// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iP-Uo","navigationContainer":"styles_navigationContainer__zrteG","iconContainer":"styles_iconContainer__p4Hlp","icon":"styles_icon__UwL1p"};